import React, { useState } from "react";
import { notify } from "../../generic";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";

function Confirm({
  open,
  setOpen,
  caption,
  onSubmitAction,
  variables,
  notify = true
}) {
  const handleModalClosure = () => {
    setOpen(false);
  };

  const handleModalSubmission = async () => {
    const callback = await onSubmitAction({ ...variables });

    if (notify) {
      const { type, message, details } = callback;

      // Gestion du type response (optionnel)
      if (type === "success") {
        notify("success", message);
        handleModalClosure();
      } else if (type === "error") {
        notify("error", message);
      }
    } else {
      handleModalClosure();
    }
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={() => handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>{caption}</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}></Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <a
            className="btn btn-cta float-end"
            type="submit"
            onClick={handleModalSubmission}
          >
            <div clasName="btn-cta-overlay"></div>
            Confirmer
          </a>
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default Confirm;
